(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["missiris-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('missiris-countdown')) {
    customElements.define('missiris-countdown', class extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-countdown-content]');
        this.help = this.querySelector('[data-countdown-help]');
        this.units = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map(unit => [unit, this.querySelector(`[data-unit="${unit}"]`)]));
        this.end = this.parseDate(this.dataset.end);
        this.start = this.dataset.start.trim() ? this.parseDate(this.dataset.start) : -Infinity;
        this.valid = this.dataset.enabled === 'true' && Number.isFinite(this.end) && (Number.isFinite(this.start) || this.start === -Infinity) && this.start < this.end;
        this.tick();
        if (this.valid && this.end > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
      parseDate(value) {
        const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/);
        if (!match) return NaN;
        const [, year, month, day, hour, minute, second = '00', zone] = match;
        if (+month < 1 || +month > 12 || +day < 1 || +hour > 23 || +minute > 59 || +second > 59) return NaN;
        const wallTime = Date.UTC(+year, +month - 1, +day, +hour, +minute, +second);
        const wallDate = new Date(wallTime);
        if (wallDate.getUTCFullYear() !== +year || wallDate.getUTCMonth() !== +month - 1 || wallDate.getUTCDate() !== +day) return NaN;
        let offset = 0;
        if (zone !== 'Z') {
          const hours = +zone.slice(1, 3), minutes = +zone.slice(4, 6);
          if (hours > 14 || minutes > 59 || (hours === 14 && minutes !== 0)) return NaN;
          offset = (zone[0] === '+' ? 1 : -1) * (hours * 60 + minutes) * 60000;
        }
        return wallTime - offset;
      }
      tick() {
        const now = Date.now();
        const visible = this.valid && now >= this.start && now < this.end;
        this.content.hidden = !visible;
        if (this.help) this.help.hidden = visible;
        if (visible) {
          const total = Math.ceil((this.end - now) / 1000);
          const values = { days: Math.floor(total / 86400), hours: Math.floor(total % 86400 / 3600), minutes: Math.floor(total % 3600 / 60), seconds: total % 60 };
          for (const [unit, value] of Object.entries(values)) this.units[unit].textContent = String(value).padStart(2, '0');
        }
        if (now >= this.end) clearInterval(this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["missiris-lookbook"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-lookbook]:not([data-ready])').forEach(function (section) {
      const dialog = section.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      section.dataset.ready = 'true';
      const cards = Array.from(section.querySelectorAll('[data-lookbook-card]'));
      const links = cards.map(function (card) { return card.querySelector('[data-lookbook-open]'); });
      const video = dialog.querySelector('video');
      const close = dialog.querySelector('[data-lookbook-close]');
      const prev = dialog.querySelector('[data-lookbook-prev]');
      const next = dialog.querySelector('[data-lookbook-next]');
      const title = dialog.querySelector('[data-lookbook-title]');
      const counter = dialog.querySelector('[data-lookbook-counter]');
      const shop = dialog.querySelector('[data-lookbook-shop]');
      const status = dialog.querySelector('[data-lookbook-status]');
      const more = section.querySelector('[data-lookbook-more]');
      const batch = Number(section.dataset.batch) || 12;
      let shown = batch;
      let index = 0;
      let trigger;
      let revision = 0;
      let previousOverflow = '';
      const previews = Array.from(section.querySelectorAll('[data-lookbook-preview]'));
      const motion = section.querySelector('[data-lookbook-motion]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let autoEnabled = !reduced.matches;
      const visible = new Set();
      const wantsPlay = (v) => autoEnabled && !document.hidden && !dialog.open && visible.has(v) && !v.closest('[data-lookbook-card]').hidden;
      function syncPreview(v) {
        if (!wantsPlay(v)) { v.pause(); if (v.getAttribute('src')) { v.removeAttribute('src'); v.load(); } v.parentElement.classList.remove('is-playing'); return; }
        if (!v.getAttribute('src')) v.src = v.dataset.src;
        v.muted = true;
        Promise.resolve(v.play()).then(function () { if (!wantsPlay(v)) { v.pause(); return; } v.parentElement.classList.add('is-playing'); }).catch(function () { v.parentElement.classList.remove('is-playing'); });
      }
      function syncGrid() { previews.forEach(syncPreview); motion.textContent = autoEnabled ? motion.dataset.pause : motion.dataset.play; motion.setAttribute('aria-pressed', String(!autoEnabled)); }
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) { entries.forEach(function(entry) { if (entry.isIntersecting && entry.intersectionRatio >= .4) visible.add(entry.target); else visible.delete(entry.target); syncPreview(entry.target); }); }, { threshold:[0,.4] }) : null;
      if (observer) { previews.forEach(function(v) { observer.observe(v); }); motion.hidden = false; syncGrid(); }
      motion.addEventListener('click', function() { autoEnabled = !autoEnabled; syncGrid(); });
      const onReduced = function() { autoEnabled = !reduced.matches; syncGrid(); };
      reduced.addEventListener('change', onReduced);
      function reveal() { cards.forEach(function (card, i) { card.hidden = i >= shown; }); more.hidden = shown >= cards.length; }
      reveal();
      more.addEventListener('click', function () { const firstNew = shown; shown += batch; reveal(); if (links[firstNew]) links[firstNew].focus(); });
      function show(i) {
        index = i;
        previews.forEach(function(v) { v.pause(); if (v.getAttribute('src')) { v.removeAttribute('src'); v.load(); } v.parentElement.classList.remove('is-playing'); });
        const current = ++revision;
        const link = links[index];
        video.pause();
        video.src = link.href;
        video.poster = link.dataset.poster;
        video.muted = true;
        video.load();
        title.textContent = link.dataset.title;
        counter.textContent = String(index + 1) + ' / ' + String(links.length);
        prev.disabled = index === 0;
        next.disabled = index === links.length - 1;
        shop.hidden = !link.dataset.productUrl;
        if (link.dataset.productUrl) shop.href = link.dataset.productUrl; else shop.removeAttribute('href');
        status.hidden = true;
        if (!dialog.open) { previousOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; dialog.showModal(); close.focus(); }
        Promise.resolve(video.play()).catch(function () { if (current === revision && dialog.open) status.hidden = false; });
      }
      links.forEach(function (link, i) { link.addEventListener('click', function (event) { if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return; event.preventDefault(); trigger = link; show(i); }); });
      close.addEventListener('click', function () { dialog.close(); });
      prev.addEventListener('click', function () { if (index > 0) show(index - 1); });
      next.addEventListener('click', function () { if (index < links.length - 1) show(index + 1); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
      dialog.addEventListener('close', function () { revision++; video.pause(); video.removeAttribute('src'); video.load(); document.documentElement.style.overflow = previousOverflow; if (trigger && trigger.isConnected) trigger.focus(); syncGrid(); });
      const onVisibility = function () { if (document.hidden) video.pause(); syncGrid(); };
      const onPageHide = function () { video.pause(); previews.forEach(function(v) { v.pause(); }); };
      document.addEventListener('visibilitychange', onVisibility);
      window.addEventListener('pagehide', onPageHide);
      section.closest('.shopify-section')?.addEventListener('shopify:section:unload', function() { observer?.disconnect(); reduced.removeEventListener('change', onReduced); document.removeEventListener('visibilitychange',onVisibility); window.removeEventListener('pagehide',onPageHide); video.pause(); previews.forEach(function(v) {v.pause();}); });
      section.addEventListener('shopify:block:select', function (event) { const card = event.target.closest('[data-lookbook-card]'); if (card) { const i = cards.indexOf(card); shown = Math.max(shown, i + 1); reveal(); } });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["missiris-photo-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('missiris-photo-reviews')) {
  customElements.define('missiris-photo-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const track = this.querySelector('.missiris-photo-reviews__track');
      const buttons = this.querySelectorAll('[data-direction]');
      const update = () => buttons.forEach(button => {
        button.disabled = Number(button.dataset.direction) < 0 ? track.scrollLeft < 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('article');
        track.scrollBy({left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["missiris-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    root.querySelectorAll('.missiris-videos:not([data-autoplay-ready])').forEach(function (section) {
      section.dataset.autoplayReady = 'true';
      const button = section.querySelector('.missiris-videos__toggle');
      let enabled = true;
      const states = Array.from(section.querySelectorAll('video')).map(function (video) {
        video.muted = true;
        video.playsInline = true;
        return { video: video, visible: false, manualPause: false, internalPause: false, pending: false, blocked: false };
      });
      function pause(state) {
        if (!state.video.paused) {
          state.internalPause = true;
          state.video.pause();
        }
      }
      function allowed(state) {
        return enabled && !motion.matches && !document.hidden && state.visible && !state.manualPause && !state.blocked;
      }
      function sync(state) {
        if (!allowed(state)) { pause(state); return; }
        if (!state.video.paused || state.pending) return;
        state.pending = true;
        state.video.muted = true;
        Promise.resolve(state.video.play()).then(function () {
          if (!allowed(state)) pause(state);
        }).catch(function () {
          state.blocked = true;
        }).finally(function () { state.pending = false; });
      }
      function update() {
        button.hidden = motion.matches || !('IntersectionObserver' in window);
        button.textContent = enabled ? button.dataset.pauseLabel : button.dataset.playLabel;
        button.setAttribute('aria-pressed', String(!enabled));
        states.forEach(sync);
      }
      states.forEach(function (state) {
        state.video.addEventListener('pause', function () {
          if (state.internalPause) { state.internalPause = false; return; }
          if (state.visible && !document.hidden && !motion.matches && enabled) state.manualPause = true;
        });
        state.video.addEventListener('play', function () {
          if (!state.pending) { state.manualPause = false; state.blocked = false; }
        });
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            const state = states.find(function (item) { return item.video === entry.target; });
            state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
            sync(state);
          });
        }, { threshold: [0, 0.25] });
        states.forEach(function (state) { observer.observe(state.video); });
      }
      button.addEventListener('click', function () {
        enabled = !enabled;
        if (enabled) states.forEach(function (state) { state.manualPause = false; state.blocked = false; });
        update();
      });
      document.addEventListener('visibilitychange', update);
      motion.addEventListener('change', update);
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());

  } catch(e) { console.error(e); }
})();
})();
